import queryString from 'query-string'
import { throwError } from 'rxjs'
import { ajax } from 'rxjs/ajax'
import { catchError } from 'rxjs/operators'
import { env } from 'shared/env'

const baseURL = env.SERVER_ADDR

const requestHeader = (is_required = false) => {
  let headers = {}
  if (!is_required) {
    headers = {
      'Content-Type': 'application/json',
    }
  }
  const userData = JSON.parse(localStorage.getItem('user_info') || '{}')
  let token: string | boolean = false
  if (userData.token) {
    token = userData.token
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  return headers
}

const handleError = (operation: string) => (err: any) => {
  const errMsg = `Error in ${operation}()`

  if (err.status === 401) {
    localStorage.clear()
    window.location.href = '/auth/login'
  }
  return throwError(() => console.error(errMsg))
}

export const getBankAccounts = () =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/bank-accounts`,
  }).pipe(catchError(handleError('getBankAccounts')))

export const getCourierSettings = () =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/courier/settings`,
  }).pipe(catchError(handleError('getCourierSettings')))

export const updateShippingLabelRemarks = (payload) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/courier/remarks`,
    body: payload,
  }).pipe(catchError(handleError('updateShippingLabelRemarks')))

export const uploadCustomerLogo = (file: any) => {
  const formData = new FormData()
  formData.append('attachment', file)
  formData.append('name', file.name)
  return ajax({
    headers: requestHeader(true),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/tenant/logo`,
    body: formData,
  }).pipe(catchError(handleError('uploadCustomerLogo')))
}

export const getAllUsers = () =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/users`,
  }).pipe(catchError(handleError('getAllUsers')))

export const getShipmentMethods = () =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/order/shipping-methods`,
  }).pipe(catchError(handleError('getShipmentMethods')))

export const updateOptions = (payload) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/options`,
    body: payload,
  }).pipe(catchError(handleError('updateOptions')))

export const updateCompany = (payload) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/tenant/company`,
    body: payload,
  }).pipe(catchError(handleError('updateCompany')))

export const validateStore = (payload) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/tenant/stores/wc/validate`,
    body: {
      ...payload,
      origin: 'settings',
    },
  }).pipe(catchError(handleError('validateStore')))

export const addCustomerPaymentMethod = (data) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/customer/${data.customer_id}/payment-method`,
    body: data,
  }).pipe(catchError(handleError('addCustomerPaymentMethod')))

export const validateShopifyStore = (payload) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/tenant/stores/shopify/validate`,
    body: {
      ...payload,
      origin: 'settings',
    },
  }).pipe(catchError(handleError('validateShopifyStore')))

export const validateDarazStore = (payload) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/tenant/stores/daraz/validate`,
    body: payload,
  }).pipe(catchError(handleError('validateDarazStore')))

export const sendTestMessage = (payload) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/communication/send/test`,
    body: payload,
  }).pipe(catchError(handleError('sendTestMessage')))

export const makeCall = (payload) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/communication/make/call`,
    body: payload,
  }).pipe(catchError(handleError('makeCall')))

export const sendEmail = (payload) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/communication/send/test`,
    body: payload,
  }).pipe(catchError(handleError('sendEmail')))

export const getDefaultOrderStatuses = () =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/order/default-status-list`,
  }).pipe(catchError(handleError('getDefaultOrderStatuses')))

export const createOrderStatus = (newOrderStatus: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/order/status`,
    body: newOrderStatus,
  }).pipe(catchError(handleError('createOrderStatus')))

export const updateOrderStatus = (update_data: any) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/order/status`,
    body: update_data,
  }).pipe(catchError(handleError('updateOrderStatus')))

export const createOrderSources = (newOrderSource: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/order/sources`,
    body: newOrderSource,
  }).pipe(catchError(handleError('createOrderSources')))

export const updateOrderSources = (newOrderSource: any) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/order/sources`,
    body: newOrderSource,
  }).pipe(catchError(handleError('updateOrderSources')))

export const addUser = (newOrderSource: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/users`,
    body: newOrderSource,
  }).pipe(catchError(handleError('addUser')))

export const exportOrders = (filters) => {
  const stringified = `?${queryString.stringify(filters)}`
  const { token } = JSON.parse(
    localStorage.getItem('user_info') || '{token: null}',
  )
  const downloadLink = document.createElement('a')
  downloadLink.href = `${baseURL}api/v2/export/main-orders/${token}${
    filters !== null ? stringified : ''
  }`
  document.body.appendChild(downloadLink)
  downloadLink.click()
  document.body.removeChild(downloadLink)
}

export const addOrderTag = (data) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/order/tags`,
    body: data,
  }).pipe(catchError(handleError('addOrderTag')))

export const addShipmentMethod = (data) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/order/shipping-methods`,
    body: data,
  }).pipe(catchError(handleError('addShipmentMethod')))

export const addPaymentMethod = (data) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/payment-gateways`,
    body: data,
  }).pipe(catchError(handleError('addPaymentMethod')))

export const updateRolePermissions = (role_id, data) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/roles/${role_id}/permissions/module`,
    body: data,
  }).pipe(catchError(handleError('updateRolePermissions')))

export const updateUser = (data) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/users/${data.id}`,
    body: data,
  }).pipe(catchError(handleError('updateUser')))

export const geRolePermissions = (roleId) =>
  ajax({
    headers: requestHeader(),
    method: 'GET',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/users/roles/${roleId}/permissions`,
  }).pipe(catchError(handleError('geRolePermissions')))

export const createCourier = (postData: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/couriers`,
    body: postData,
  }).pipe(catchError(handleError('createCourier')))

export const updateCourier = (courier_id, postData: any) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/couriers/${courier_id}`,
    body: postData,
  }).pipe(catchError(handleError('updateCourier')))

export const updateCourierInfo = (
  courier_id: number,
  postData: string | object,
) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/couriers/${courier_id}/info`,
    body: postData,
  }).pipe(catchError(handleError('updateCourierInfo')))

export const updateCourierCredentials = (
  courier_id: number,
  postData: string | object,
) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/couriers/${courier_id}/credentials`,
    body: postData,
  }).pipe(catchError(handleError('updateCourierCredentials')))

export const updateCourierStatus = (courier_id, postData: any) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/couriers/status/${courier_id}`,
    body: postData,
  }).pipe(catchError(handleError('updateCourierStatus')))

export const deleteCourier = (courier_id) =>
  ajax({
    headers: requestHeader(),
    method: 'DELETE',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/couriers/${courier_id}`,
  }).pipe(catchError(handleError('deleteCourier')))

export const changePasswordAPI = (data, id) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/users/${id}/password`,
    body: data,
  }).pipe(catchError(handleError('changePasswordAPI')))

export const storeAccessToken = (payload) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/communication/whatsapp/access-token`,
    body: payload,
  }).pipe(catchError(handleError('storeAccessToken')))

export const handleAddRider = (data: any, courier_id: any) =>
  ajax({
    headers: requestHeader(),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/settings/couriers/${courier_id}/riders`,
    body: data,
  }).pipe(catchError(handleError('handleAddRider')))

export const updateReceivedPayments = (data) =>
  ajax({
    headers: requestHeader(),
    method: 'PUT',
    withCredentials: false,
    url: `${baseURL}api/v2/courier/payments/recorded/${data.courier_payment_id}`,
    body: data,
  }).pipe(catchError(handleError('updateReceivedPayments')))

export const uploadExcelSheet = (file, data) => {
  const formData = new FormData()
  if (file) {
    formData.append('file', file, file)
  }
  formData.append('file_data', JSON.stringify(data))
  return ajax({
    headers: requestHeader(true),
    method: 'POST',
    withCredentials: false,
    url: `${baseURL}api/v2/order/${data?.id}/upload-order`,
    body: formData,
  }).pipe(catchError(handleError('uploadExcelSheet')))
}
